import { type ReactNode, useState } from 'react';

/**
 * A screenshot that falls back to `fallback` when there is none or it fails to
 * load (a deleted app's preview, an expired link), instead of a broken image.
 */
export function Thumbnail({ src, className, fallback }: { src?: string; className?: string; fallback: ReactNode }) {
  const url = src?.trim();
  const [failed, setFailed] = useState<string>();
  if (!url || failed === url) return <>{fallback}</>;
  return <img src={url} alt="" className={className} loading="lazy" onError={() => setFailed(url)} />;
}
